import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FeaturedClustersService } from "@/core/services/featured-clusters.service";

@Pipe({
  name: 'featuredCluster',
  pure: true,
})
export class FeaturedClusterPipe implements PipeTransform {
  public constructor(private readonly _featuredClustersService: FeaturedClustersService) { }

  public transform(id: number): Observable<boolean> {
    return this._featuredClustersService.getFeaturedClusters().pipe(
      map((next) => next.map(item => item.id).includes(id, 0)),
    );
  }
}
